module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rfm1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Acknowledgments#fm1"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rfm2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Foreword#fm2"
    }
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rfm3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Preface#fm3"
    }
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter001#ch1"
    }
  }, [_vm._v("1")]), _c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter001#ch1"
    }
  }, [_c('i', [_vm._v("Small Is Profitable")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter001#sec1"
    }
  }, [_vm._v("Can You Really Live off 1.5 Acres?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter001#sec2"
    }
  }, [_vm._v("Not Just Making a Good Living, but Making a Good Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter002#ch2"
    }
  }, [_vm._v("2")]), _c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter002#ch2"
    }
  }, [_c('i', [_vm._v("Succeeding as a Small-Scale Organic Vegetable Grower")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter002#sec3"
    }
  }, [_vm._v("A Biologically Intensive Approach")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter002#sec4"
    }
  }, [_vm._v("Minimizing Start-Up Costs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter002#sec5"
    }
  }, [_vm._v("Minimizing Production Costs")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter002#sec6"
    }
  }, [_vm._v("Direct Selling")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter002#sec7"
    }
  }, [_vm._v("Adding Value to the Crops")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/Text/Chapter002#sec8"
    }
  }, [_vm._v("Learning the Craft")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Finding the Right Site")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Climate and Microclimate")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Market Access")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec11"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Growing Space Needed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec12"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soil Quality")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec13"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Topography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec14"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Drainage")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec15"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Access to Water")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec16"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infrastructure")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec17"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter003#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Assessing Possible Pollution Problems")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Designing the Market Garden")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec18"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter004#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Buildings and Foot Traffic")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec19"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter004#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Standardizing the Garden Layout")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec20"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter004#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Locating the Greenhouse and Tunnels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec21"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter004#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protection against Deer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec22"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter004#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Windbreaks")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec23"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter004#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irrigation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Minimum Tillage and Appropriate Machinery")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec24"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter005#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Permanent Raised Beds")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec25"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter005#sec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Two-Wheel Tractor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec26"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter005#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Broadfork (Grelinette)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec27"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter005#sec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tarps and Pre-Crop Ground Cover")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec28"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter005#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("To Till or not to Till")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Fertilizing Organically")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec29"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#sec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soil Tests")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec30"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crop Requirements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec31"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#sec31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Managing Soil Fertility")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec32"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Compost")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec33"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#sec33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relying on Natural Fertilizers — Why?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec34"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Establishing Crop Rotation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec35"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#sec35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crop Rotation at Les Jardins de la Grelinette")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec36"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#sec36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Green Manure and Cover Crops")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec37"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter006#sec37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connecting with Soil Ecology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Starting Seeds Indoors")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec38"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#sec38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seeding in Cell Flats")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec39"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#sec39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Soil Mix")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec40"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Filling Cell Flats")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec41"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#sec41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Seedling Room")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec42"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#sec42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evolving Plant Nursery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec43"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#sec43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heating and Ventilation of the Nursery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec44"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#sec44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Water Seedlings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec45"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#sec45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Potting up")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec46"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter007#sec46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transplanting into the Gardens")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Direct Seeding")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec47"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter008#sec47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Precision Seeders")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec48"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter008#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seedbed Preparation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec49"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter008#sec49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Record Keeping")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Weed Management")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec50"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter009#sec50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cultivating with Hoes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec51"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter009#sec51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Weeding with Tarps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec52"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter009#sec52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Stale Seedbed Technique")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec53"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter009#sec53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flame Weeding")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec54"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter009#sec54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mulching")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec55"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter009#sec55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Weed Control Technology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chaptera",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Insect Pests and Diseases")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec56"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter010#sec56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scouting")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec57"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter010#sec57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disease Prevention")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec58"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter010#sec58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Using Biopesticides")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chaptera",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Season Extension")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec59"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter011#sec59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Floating Row Cover and Low Tunnels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec60"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter011#sec60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caterpillar Tunnels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec61"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter011#sec61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hoophouses")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chaptera",
    attrs: {
      "id": "rch12"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Harvest and Storage")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec62"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter012#sec62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harvesting Efficiently")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec63"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter012#sec63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harvest Help")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec64"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter012#sec64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cold Room")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chaptera",
    attrs: {
      "id": "rch13"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Text/Chapter013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Crop Planning")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec65"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter013#sec65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Setting Farming Objectives")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec66"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter013#sec66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Determining Production")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec67"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter013#sec67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Establishing a Crop Calendar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec68"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter013#sec68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Making a Garden Plan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-lev",
    attrs: {
      "id": "rsec69"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Chapter013#sec69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Record Keeping")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front1",
    attrs: {
      "id": "rbm1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Conclusion#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Farming for Ecology, Community, and Lifestyle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rbm2"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Appendix001#bm2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Crop Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rbm3"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Appendix002#bm3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: Tools and Suppliers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rbm4"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Appendix003#bm4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3: Garden Plan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rbm5"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Appendix004#bm5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 4: Annotated Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rbm6"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Appendix005#bm6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 5: Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rbm7"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Index#bm7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-front",
    attrs: {
      "id": "rbm8"
    }
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/Text/Abouttheauthor#bm8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0388b1f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Contents.vue
// module id = 69
// module chunks = 0